var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9222 10.5402C8.83347 11.4836 7.44061 12.002 6 12C2.6862 12 0 9.3138 0 6C0 2.6862 2.6862 0 6 0C9.3138 0 12 2.6862 12 6C12 7.2816 11.598 8.4696 10.914 9.444L9 6H10.8C10.7999 4.89372 10.4177 3.82144 9.718 2.96453C9.01832 2.10763 8.04412 1.51872 6.9602 1.29741C5.87628 1.07611 4.7492 1.23601 3.76961 1.75006C2.79001 2.26411 2.01805 3.10075 1.58431 4.11845C1.15057 5.13615 1.08168 6.27243 1.38929 7.33508C1.69691 8.39773 2.36214 9.3215 3.27245 9.95013C4.18276 10.5788 5.28228 10.8737 6.38499 10.7849C7.4877 10.6962 8.52591 10.2293 9.324 9.46319L9.9222 10.5402Z",
    fill: "#F6A74A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/RefreshIcon.8838fdddfa605864a80d336a03dfdc23.svg";
export { ForwardRef as ReactComponent };